import React, { useState, useEffect } from "react";
import { usePageMessageBrokerListener } from "./use_page_message_broker_listener";

export default function ShowNewFile() {
  const [message, setMessage] = useState(null);

  useEffect(() => {
    const container = document.getElementById("show-new-file");
    if (container) {
      if (message) {
        container.style.display = "block";
      }
      else {
        container.style.display = "none";
      }
    }

    return () => null;
  }, [message]);

  usePageMessageBrokerListener('notice', (data) => {
    setMessage(data.text);
  });

  if (!message) {
    return null
  }

  return (
    <div className="bg-material-50 border border rounded-lg border-material-500 shadow-sm p-4" id="show-new-file">
      {message && <p>{message}</p>}
    </div>
  );
}

